import { pathname } from "store/reducers/ActionCreators";
import notifyError from "utils/Notifications/Error";
import cookie from "js-cookie";
import Success from "./Notifications/Success";
import { store } from "store/store";
import { setWsReadyLogs } from "store/reducers/LogsSlice";

const errors = {
    no_con: "No WS connection was found",
    invalid_arg: "Invalid argument provided",
    closed_before_init: "WS closed before connection established",
};

enum SocketEvents {
    get_workspace = "get_workspace",
}

type MemoCallback = {
    event: WSEvent;
    callback: any;
};

export type SavedConnection = {
    name: string;
    connection: WebSocket;
    id: number | string;
};

type WSEvent = keyof typeof SocketEvents;

const _pathname = pathname.replace("https://", "").replace("http://", "");

const urls = {
    get_workspace: `${process.env.REACT_APP_SOCKET_SECURE}${_pathname}/wss`,
};

const actions = {
    get_workspace: (args: any[]): string => {
        if (!args || !Array.isArray(args)) {
            console.log(1);

            WS.handleError(errors.invalid_arg);
        }
        const tab_name = args[0];
        return `${urls.get_workspace}/${tab_name}/`;
    },
};

class WS {
    _connection: WebSocket;
    callbacks: MemoCallback[] = [];
    _active_tab: string;
    robotError: string = "";
    SSE_connection: EventSource;
    saved_tabs: SavedConnection[] = [];
    _isConnecting: boolean = false;
    _pendingConnect: any = null;
    _connectingTabId: string | null = null;
    constructor() {
        this.connect = this.connect.bind(this);
        this.listen = this.listen.bind(this);
        this._registerCallback = this._registerCallback.bind(this);
        this._unRegisterCallback = this._unRegisterCallback.bind(this);
        this.drop = this.drop.bind(this);
    }
    closeTab(tabId: string | number) {
        const index = this.saved_tabs.findIndex(
            (t) => String(t.id) === String(tabId),
        );
        if (index !== -1) {
            const saved = this.saved_tabs[index];
            if (saved.connection && saved.connection.readyState < 2) {
                console.log(`[WS] Closing specific tab ${tabId}`);
                saved.connection.close(1000, "Tab closed");
            }
            this.saved_tabs.splice(index, 1);


            if (this._active_tab === String(tabId)) {
                this._connection = null as any;
            }
        }
    }
    drop(excludeTabId?: string) {
        const states = [WebSocket.OPEN, WebSocket.CONNECTING];

        this.saved_tabs = this.saved_tabs.filter((saved) => {
            const conn = saved.connection;


            if (excludeTabId && saved.id === excludeTabId) {
                return true; 
            }

            if (conn && states.includes((conn as any).readyState)) {
                try {
                    console.log(
                        `[WS] Closing connection for tab ${saved.name || saved.id}`,
                    );
                    conn.close(1000, "Switching robot");
                } catch (e) {
                    console.warn("Error closing WS", e);
                }
            }
            return false; // удаляем из массива
        });

        this.callbacks = [];
        this._connection = null as any;
    }

    disconnectAll(excludeTabId?: string) {
        console.log(
            "[WS] disconnectAll() called - cleaning up all connections",
            excludeTabId ? `excluding tab ${excludeTabId}` : "",
        );

        this.drop(excludeTabId);

        if (this.SSE_connection) {
            try {
                console.log("[SSE] Closing old EventSource connection");
                this.SSE_connection.close();
            } catch (e) {
                console.warn("[SSE] Error while closing EventSource", e);
            }
            this.SSE_connection = null as any;
        }

        this.robotError = "";
        this._active_tab = "";
        this.callbacks = [];

        console.log("[WS] disconnectAll() completed");
    }
    addListeners(socket: WebSocket) {
        const listeners = [];
    }

    get connection(): WebSocket {
        const con = this._connection;
        if (!con) {
            // WS.handleError(errors.no_con);
        }
        return this._connection;
    }

    set connection(con: WebSocket) {
        this._connection = con;
    }

    async connect({
        tab_id,
        onUpdate,
        name,
        robotId,
    }: {
        tab_id: string;
        onUpdate: (q: any) => void;
        name: string;
        robotId: string;
    }) {

        if (this._isConnecting) {
            console.log(
                `[WS] Connect already in progress, queuing for tab ${tab_id}`,
            );
            this._pendingConnect = { tab_id, onUpdate, name, robotId };
            return;
        }

        this._isConnecting = true;
        this._connectingTabId = tab_id;
        this.active_tab = tab_id;


        this.drop(tab_id);

        const url = WS.createWSUrl({
            event: "get_workspace",
            args: [tab_id],
            robotId,
        });

        let ws: WebSocket;
        try {
            ws = new WebSocket(url);
        } catch (error) {
            console.log(2);
            WS.handleError(error);
            this._isConnecting = false;

       
            if (this._pendingConnect) {
                const pending = this._pendingConnect;
                this._pendingConnect = null;
                this.connect(pending);
            }
            return;
        }

        this.saved_tabs.push({
            name,
            id: tab_id,
            connection: ws,
        });

        ws.addEventListener("open", () => {
            console.log(`[WS] Connection opened for tab ${tab_id}`);
            this._isConnecting = false;
            this._connectingTabId = null;
            const message = name
                ? `Соединение со вкладкой ${name} установлено`
                : "Соединение установлено";
            store.dispatch(setWsReadyLogs(true));
            Success(message);

            ws.send(JSON.stringify({ message: "ok" }));


            if (this._pendingConnect) {
                const pending = this._pendingConnect;
                this._pendingConnect = null;
                this.connect(pending);
            }
        });

        ws.addEventListener("message", onUpdate);

        ws.addEventListener("close", (event) => {
            console.log(
                `[WS] Connection closed for tab ${tab_id}`,
                event.code,
                event.reason,
            );
            if (this._connectingTabId === tab_id) {
                this._connectingTabId = null;
            }
        });
let isIntentionalClose = false;

        ws.addEventListener("error", (error) => {
            isIntentionalClose = true;
            console.error(`[WS] Connection error for tab ${tab_id}`);
            console.error(`error`, error);
            if (this._connectingTabId === tab_id) {
                this._connectingTabId = null;
            }
            this._isConnecting = false;
            console.log(3);

    if (!isIntentionalClose) {
        WS.handleError(error); 
    }
            if (this._pendingConnect) {
                const pending = this._pendingConnect;
                this._pendingConnect = null;
                this.connect(pending);
            }
        });

        this.connection = ws;
    }

    listen(event: WSEvent, callback: any) {
        return this._registerCallback(event, callback);
    }

    _registerCallback(event: WSEvent, callback: any) {
        const con = this.connection;
        if (!con) {
            return;
        }
        con.onmessage = (event: any) => {
            console.log("event", event);
        };
        //con.addEventListener('message', callback);
        this.callbacks.push({
            event,
            callback,
        });
    }

    _unRegisterCallback(event: WSEvent) {
        const con = this.connection;
        const found_callback = this.callbacks.find((cb) => cb.event === event);
        if (found_callback && con) {
            con.removeEventListener("message", found_callback.callback);
            this.callbacks = this.callbacks.filter((cb) => cb.event !== event);
        }
    }

    static createWSUrl({
        event,
        args,
        robotId,
    }: {
        event: WSEvent;
        args: any[];
        robotId: string;
    }) {
        const url = actions[event]([...args]);
        const token = cookie.get("access");
        return `${url}?token=${token}&robot_id=${robotId}`;
    }
    static handleError(error: string | Event) {
        if (error instanceof Event && error.target instanceof WebSocket) {
            const ws = error.target;
            console.error("WS Error details:", {
                url: ws.url,
                readyState: ws.readyState, // 0=CONNECTING, 1=OPEN, 2=CLOSING, 3=CLOSED
                protocol: ws.protocol,
            });
            console.log("handleError error", error);

            notifyError(`Не удалось подключиться: ${ws.url}`);
        } else {
            console.error("Received error", error);
        }
    }

    get active_tab() {
        return this._active_tab;
    }
    set active_tab(tab: string) {
        this._active_tab = tab;
    }
}

export default new WS();
